export enum FlightArrivalDayPolicyEnum {
  NONE = 'NONE',
  SAME_DAY = 'SAME_DAY',
  TOMORROW = 'TOMORROW',
}
